import { useAuth } from '../../hooks/useAuth'

const Header = () => {
  const { user, logout } = useAuth()

  return (
    <header className="h-16 bg-white border-b border-gray-200 shadow-sm sticky top-0 z-40">
      <div className="h-full px-6 flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-3">
          <img
            src="/savian-logo.png"
            alt="Savian Guardian"
            className="h-10"
          />
        </div>

        <div className="flex items-center gap-4">
          <span className="text-sm text-gray-700">{user?.nombre || 'Usuario'}</span>
          <button
            onClick={logout}
            className="text-sm text-gray-600 hover:text-gray-900 transition-colors"
          >
            Cerrar sesión
          </button>
        </div>
      </div>
    </header>
  )
}

export default Header
